const INNITIAL_STATE = {
  redirect: () => null
};

/** Retorna o estado atualizado */
export default function redirect(state = INNITIAL_STATE, action) {
  switch (action.type) {
    case "REDIRECT_FN_SET":
      return {
        ...state,
        redirect: action.redirect
      };
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/redirect.js